// removed by extract-text-webpack-plugin
module.exports = {"container":"container___1MEqU","wrapper":"wrapper___2aJYs","logo":"logo___23fUc","info":"info___ZWBQ5","modal":"modal___16u48","header":"header___1DMeZ","body":"body___tHuwB","close":"close___1Hcgg","overlay":"overlay___1G_0S","hidden":"hidden___2mBBb","cart":"cart___30u8R","items":"items___2_bha","name":"name___2Ao7l","price":"price___2ta4E","icon":"icon___3DkcU","total":"total___3inBV","main":"main___1E5lh","lighter":"lighter___30rXU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Cart.scss
// module id = 26
// module chunks = 0